<template>
  <section-layout
    :showButton="false"
  >
    <template v-slot:title>
      {{localization.tabsTitles.relacionIncidencias}}
    </template>
    <template v-slot:content>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <o-medium-title class="pr-5">
              {{localization.filtros.title}}
            </o-medium-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <filtrosIncidencias
              tipo="relacionIncidencias"
              :disabled="loading"
              @aplicar="aplicarFiltros"
              @borrar="borrarFiltros"
              @exportar="exportarExcel"
              @toogleHeaderNotas="toogleHeaderNotas"
              @toogleHeaderObservaciones="toogleHeaderObservaciones"
              @toogleHeaderClientes="toogleHeaderClientes"
              :itramit="true"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card class="mt-4">
        <v-container fluid>
          <v-data-table
            :headers="headers"
            :items="incidencias"
            :search="tableSearch"
            :loading="loading"
            item-key="incidenciaId"
            :footer-props="{
              'items-per-page-text': $t('filasPorPagina'),
              'items-per-page-options': [10, 20, 30, 40, 50, -1]
            }"
          >
            <template v-slot:top>
              <v-row no-gutters justify="end" align="center">
                <v-col cols="4">
                  <v-text-field
                    v-model="tableSearch" id="tableSearch"
                    :label="localization.filtros.buscar" prepend-icon="search"
                  />
                </v-col>
              </v-row>
            </template>
            <template
              v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.incidenciaId">
                  <!--<td>{{ item.incidenciaId }}</td>-->
                  <td>{{ item.referencia }}</td>
                  <td>{{ item.visitaReferencia }}</td>
                  <td>{{ traduccionTipoSolicitud(item) }}</td>
                  <td>{{ item.nombreResponsable }}</td>
                  <td>{{ item.desc_delegacion }}</td>
                  <td>{{ item.cod_promocion }}</td>
                  <td>{{ item.propertyDevelopment }}</td>
                  <td>{{ item.provincia }}</td>
                  <td>{{ item.sector }}</td>
                  <td v-html="item.uhedit"></td>
                  <td v-html="item.location"></td>
                  <td>{{ item.poblacion }}</td>
                  <td v-if="idubapi.motor !== 'SIN_BD'">{{ item.valorCP }}</td>
                  <td>{{ traduccionLocalizacion(item) }}</td>
                  <td class="recortarStyle">{{ item.description }}</td>
                  <td>{{ item.openDate }}</td>
                  <td>{{ item.notificationDate }}</td>
                  <td>{{ traduccionOficio(item) }}</td>
                  <td>{{ traduccionEstado(item) }}</td>
                  <td>{{ traduccionUrgencia(item) }}</td>
                  <td>{{ item.codigoProveedor }}</td>
                  <td>{{ item.proveedor }}</td>
                  <td>{{ item.fechaEnvioParte }}</td>
                  <td>{{ item.finishDate }}</td>
                  <td>{{ item.fechaFinalizacion }}</td>
                  <td v-if="idubapi.motor !== 'SIN_BD'">{{ item.fechaEscrituracion }}</td>
                  <td>{{ item.fechaEstado }}</td>
                  <td>{{ item.fechaRespuestaObra }}</td>
                  <td>{{ diasAvisoResponsableObra(item) }}</td>
                  <td>{{ diasAvisoFechaFinReal(item) }}</td>
                  <td>{{ item.costeReal }}</td>
                  <td>{{ item.fechaReapertura }}</td>
                  <td>{{ item.incidenciaPredefinida }}</td>
                  <td>{{ item.origen }}</td>
                  <td v-if="headerNotas.length === 1">
                    <template>
                      <v-icon v-if="item.notas.length > 0" color="primary lighten-1" @click="abrirDialog('Notas', item)" style="cursor: pointer;">mdi-eye</v-icon>
                    </template>
                  </td>
                  <td v-if="headerObservaciones.length === 1">
                    <template>
                      <v-icon v-if="item.observacionesEstado !== '' && item.observacionesEstado !== null" color="primary lighten-1" @click="abrirDialog('Observaciones', item)" style="cursor: pointer;">mdi-eye</v-icon>
                    </template>
                  </td>

                  <td v-if="headerClientes.length > 0">{{ item.cliente }}</td>
                  <td v-if="headerClientes.length > 0">{{ item.clienteTelefono }}</td>
                  <td v-if="headerClientes.length > 0">{{ item.movilCliente }}</td>
                  <td v-if="headerClientes.length > 0">{{ item.emailCliente }}</td>
                  <td v-if="headerClientes.length > 0">{{ item.contacto }}</td>
                  <td v-if="headerClientes.length > 0">{{ item.telefono }}</td>
                  <td v-if="headerClientes.length > 0">{{ item.observaciones }}</td>

                </tr>
              </tbody>
            </template>
            <!-- <template v-slot:item.location="{item}">
              <div v-html="item.location"/>
            </template> -->
          </v-data-table>
        </v-container>
      </v-card>
      <v-dialog
        v-model="dialog" id="dialog"
        scrollable
        height="300"
        width="800"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            {{tituloDialog}}
          </v-card-title>

          <v-card-text v-if="notasDialog.length > 0">
            <v-list class="py-0" light>
              <v-list-item-group>
                <v-list-item
                  v-for="item in notasDialog"
                  :key="item.id"
                  disabled
                >
                  <v-list-item-content>
                    <span class="primary--text" style="max-width: 100%">
                      {{formateaFecha(item.fecha)}} - {{item.nota}}
                    </span>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-card-text v-if="observacionesEstado.length > 0">
            <v-list class="py-0" light>
              <v-list-item-group>
                <v-list-item
                  v-for="item in observacionesEstado"
                  :key="item.id"
                  disabled
                >
                  <v-list-item-content>
                    <span class="primary--text" style="max-width: 100%">
                      {{formateaFechaHora(item)}} - {{item.descripcion}} - {{item.observaciones}}
                    </span>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">{{$t('cerrar')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </section-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import filtrosIncidencias from './filtrosIncidencias'
import mixinExcel from '@/mixins/downloadExcel'
import moment from 'moment'

export default {
  mixins: [mixinExcel],
  components: {
    filtrosIncidencias
  },
  data () {
    return {
      loading: false,
      tableSearch: '',
      incidencias: [],
      loader: null,
      headerNotas: [],
      headerObservaciones: [],
      headerClientes: [],
      dialog: false,
      tituloDialog: '',
      observacionesEstado: '',
      notasDialog: []
    }
  },
  computed: {
    ...mapGetters ({
      idubapi: 'login/idubapi'
    }),
    localization () {
      return this.$t('sectionInformes')
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    headers () {
      let headerEscrituracion = this.idubapi.motor !== 'SIN_BD' ? [{ text: this.localization.relacionIncidencias.fechaEscrituracion, value: 'fechaEscrituracion' }] : []
      let headerValorCP = this.idubapi.motor !== 'SIN_BD' ? [{ text: this.localization.relacionIncidencias.valorCP, value: 'valorCP' }] : []

      return [
        { text: this.localization.relacionIncidencias.referencia, value: 'incidenciaId' },
        { text: this.localization.filtros.tipoVisita, value: 'visitaReferencia'},
        { text: this.localization.relacionIncidencias.tipoSolicitud, value: 'tipoSolicitud' },
        { text: this.localization.estadisticas.responsable, value: 'nombreResponsable' },
        { text: this.localization.relacionIncidencias.delegacion, value: 'desc_delegacion' },
        { text: this.localization.relacionIncidencias.cod_promocion, value: 'cod_promocion' },
        { text: this.localization.relacionIncidencias.promocion, value: 'propertyDevelopment' },
        { text: this.localization.relacionIncidencias.provincia, value: 'provincia' },
        { text: this.localization.relacionIncidencias.sector, value: 'sector' },
        { text: this.localization.relacionIncidencias.idInmueble, value: 'idInmueble' },
        { text: this.localization.relacionIncidencias.ubicacion, value: 'location' },
        { text: this.localization.relacionIncidencias.poblacion, value: 'poblacion' },
        ...headerValorCP,
        { text: this.localization.relacionIncidencias.localizacion, value: 'room' },
        { text: this.localization.relacionIncidencias.descripcion, value: 'description' },
        { text: this.localization.relacionIncidencias.entrada, value: 'openDate' },
        { text: this.localization.relacionIncidencias.aviso, value: 'notificationDate' },
        { text: this.localization.relacionIncidencias.oficio, value: 'profession' },
        { text: this.localization.relacionIncidencias.estado, value: 'state' },
        { text: this.localization.relacionIncidencias.urgencia, value: 'urgencia' },
        { text: this.localization.relacionIncidencias.codigoProveedor, value: 'codigoProveedor' },
        { text: this.localization.relacionIncidencias.proveedor, value: 'proveedor' },
        { text: this.localization.relacionIncidencias.envioParte, value: 'fechaEnvioParte' },
        { text: this.localization.relacionIncidencias.fechaFinPrevista, value: 'finishDate' },
        { text: this.localization.relacionIncidencias.fechaFinalizacion, value: 'fechaFinalizacion' },
        ...headerEscrituracion,
        { text: this.localization.relacionIncidencias.fechaEstado, value: 'fechaEstado' },
        { text: this.localization.relacionIncidencias.fechaRespuestaObra, value: 'fechaRespuestaObra' },
        { text: this.localization.relacionIncidencias.diasAvisoResponsableObra, value: 'diasAvisoResponsableObra' },
        { text: this.localization.relacionIncidencias.diasAvisoFechaFinReal, value: 'diasAvisoFechaFinReal' },
        { text: this.localization.relacionIncidencias.costeReal, value: 'costeReal' },
        { text: this.localization.relacionIncidencias.fechaReapertura, value: 'fechaReapertura' },
        { text: this.localization.relacionIncidencias.incidenciaPredefinida, value: 'incidenciaPredefinida' },
        { text: this.localization.relacionIncidencias.origen, value: 'origen' },
        ...this.headerNotas,
        ...this.headerObservaciones,
        ...this.headerClientes
      ]
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getIncidencias: 'informes/getIncidencias'
    }),
    toogleHeaderNotas (val) {
      this.headerNotas = val ? [{ text: this.localization.relacionIncidencias.notas, value: 'notas' }] : []
    },
    toogleHeaderObservaciones (val) {
      this.headerObservaciones = val ? [{ text: this.localization.relacionIncidencias.observacionesEstado, value: 'observaciones' }] : []
    },
    toogleHeaderClientes (val) {
      this.headerClientes = val ?
          [
            { text: this.localization.relacionIncidencias.cliente, value: 'cliente' },
            { text: this.localization.relacionIncidencias.clienteTelefono, value: 'clienteTelefono' },
            { text: this.localization.relacionIncidencias.movilCliente, value: 'movilCliente' },
            { text: this.localization.relacionIncidencias.emailCliente, value: 'emailCliente' },
            { text: this.localization.relacionIncidencias.contacto, value: 'contacto' },
            { text: this.localization.relacionIncidencias.telefono, value: 'telefono' },
            { text: this.localization.relacionIncidencias.observacionesCl, value: 'observaciones' }

          ]
        : []
    },
    async aplicarFiltros (values) {
      try {
        this.loading = true
        /*
        // 317137 - Esto no hay que filtrarlo, si no está definido sacamos todo.
        if ( values.status.length === 0 ) {
          values.status =  this.$store.state.incidencias.estadosFiltroInicial
        }*/
        var respuesta = await this.getIncidencias(values)
        this.incidencias = respuesta.data
      } catch (error) {
        console.log('ERROR AL CARGAR DATOS? filtros', error)
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.loading = false
    },
    borrarFiltros () {
      this.incidencias = []
    },
    async exportarExcel (values) {
      try {
        this.loading = true
        let csv = await this.getIncidencias(values)
        this.downloadExcel(csv.file || csv.data)
      } catch (error) {
        console.log('ERROR AL CARGAR DATOS? descarga', error)
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.loading = false
    },
    abrirDialog(tipo, item) {
      this.dialog = true
      this.tituloDialog = tipo
      this.observacionesEstado = []
      this.notasDialog = []

      if(tipo === 'Observaciones') {
        this.observacionesEstado = item.observacionesEstado
      } else {
        this.notasDialog = item.notas
      }
      console.log(item)

    },
    formateaFecha(fecha) {
      console.log('fecha', fecha)
      return moment(fecha, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    formateaFechaHora(item) {

      if(item.fechaAlta) {
        return moment(item.fechaAlta, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm')
      } else {
        return moment(item.fecha, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }

    },
    traduccionTipoSolicitud (item) {
      if(this.usuario.idioma === 'spa') {
        return item.tipoSolicitud
      } else {
        let tradTipoSolicitud = JSON.parse(item.traduccionTipoSolicitud)
        if(tradTipoSolicitud) {
          return tradTipoSolicitud[this.usuario.idioma] || item.tipoSolicitud
        } else {
          return item.tipoSolicitud
        }
      }
    },
    traduccionLocalizacion (item) {
      if(this.usuario.idioma === 'spa') {
        return item.room
      } else {
        let tradRoom = JSON.parse(item.traduccionEstancia)
        if(tradRoom) {
          return tradRoom[this.usuario.idioma] || item.room
        } else {
          return item.room
        }
        
      }
    },
    traduccionOficio (item) {
      if(this.usuario.idioma === 'spa') {
        return item.profession
      } else {
        let tradOficio = JSON.parse(item.traduccionOficio)
        if(tradOficio) {
          return tradOficio[this.usuario.idioma] || item.profession
        } else {
          return item.profession
        }
        
      }
    },
    traduccionUrgencia (item) {
      if(this.usuario.idioma === 'spa') {
        return item.urgencia
      } else {
        let tradUrgencia = JSON.parse(item.traduccionUrgencia)
        if(tradUrgencia) {
          return tradUrgencia[this.usuario.idioma] || item.urgencia
        } else {
          return item.urgencia
        }
        
      }
    },
    traduccionEstado (item) {
      if(this.usuario.idioma === 'spa') {
        return item.state
      } else {
        let tradEstado = JSON.parse(item.traduccionEstado)
        if(tradEstado) {
          return tradEstado[this.usuario.idioma] || item.state
        } else {
          return item.state
        } 
      }
    },
    diasAvisoResponsableObra (item) {
      if ( (item.notificationDate != null && item.notificationDate != '') && ( item.fechaRespuestaObra != '' && item.fechaRespuestaObra != null)) {
        console.log(item.notificationDate)
        let fechaAviso = moment(item.notificationDate,'DD/MM/YYYY')
        let fechaResponsableObra = moment(item.fechaRespuestaObra, 'DD/MM/YYYY')
        let diff = fechaResponsableObra.diff(fechaAviso, 'days')
        if ( diff < 0 ) {
          diff = fechaAviso.diff(fechaResponsableObra, 'days')
        }
          
        return diff
      }
      else {
        return ''
      }
      
    },
    diasAvisoFechaFinReal (item) {
      if ( (item.notificationDate != null && item.notificationDate != '') && ( item.fechaFinalizacion != '' && item.fechaFinalizacion != null)) {
        let fechaAviso = moment(item.notificationDate,'DD/MM/YYYY')
        let fechaFinReal = moment(item.fechaFinalizacion,'DD/MM/YYYY')
        let diff = fechaFinReal.diff(fechaAviso, 'days')
        if ( diff < 0 ) {
          diff = fechaAviso.diff(fechaFinReal, 'days')
        }
        return diff
      }
      else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.recortarStyle {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 150px;
  }
</style>
